

import {
    SET_CHASSEURS_LOADING,
    SET_CHASSEURS_ERROR,

    FETCH_CHASSEURS_SUCCESS,
    FETCH_CHASSEURS_FAIL,

    CREATE_CHASSEUR_FAIL,
    UPDATE_CHASSEUR_FAIL,

    DELETE_CHASSEUR_SUCCESS,
    DELETE_CHASSEUR_FAIL,

    // Domaines
    FETCH_DOMAINES_SUCCESS,
    FETCH_DOMAINES_FAIL,
} from "../actions/chasseursActions";

const initialState = {
    loading: false,
    error: null,
    chasseurs: [],

    // Domaines
    domaines: [],
};

export default function chasseursReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CHASSEURS_LOADING:
            return { ...state, loading: action.payload };

        case SET_CHASSEURS_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CHASSEURS_SUCCESS:
            return { ...state, chasseurs: action.payload || [], error: null };

        case FETCH_CHASSEURS_FAIL:
        case CREATE_CHASSEUR_FAIL:
        case UPDATE_CHASSEUR_FAIL:
        case DELETE_CHASSEUR_FAIL:
        case FETCH_DOMAINES_FAIL:
            return { ...state, error: action.payload };

        case DELETE_CHASSEUR_SUCCESS:
            return { ...state, chasseurs: state.chasseurs.filter((c) => c.id !== action.payload), error: null };

        case FETCH_DOMAINES_SUCCESS:
            return { ...state, domaines: action.payload || [], error: null };

        default:
            return state;
    }
}
